var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 38,
    viewBox: "0 0 103 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.768 20.7678C102.744 19.7915 102.744 18.2085 101.768 17.2322L85.8579 1.32233C84.8816 0.34602 83.2986 0.34602 82.3223 1.32233C81.346 2.29864 81.346 3.88155 82.3223 4.85786L96.4645 19L82.3223 33.1421C81.346 34.1184 81.346 35.7014 82.3223 36.6777C83.2986 37.654 84.8816 37.654 85.8579 36.6777L101.768 20.7678ZM0 21.5H100V16.5H0L0 21.5Z",
    fill: "#EEF2F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c360f14909a61e9928ff6031b08795a5.svg";
export { ForwardRef as ReactComponent };